import { createApiActionCreator } from 'omni-common-ui';
import { buildUrl } from 'domain/Api';

const ACTION_OBJECT_NAME = 'ONLINE_HOMEWORK_HF_USAGE';
export const FETCH_ONLINE_HOMEWORK_HF_USAGE_REQUEST = `FETCH_${ACTION_OBJECT_NAME}_REQUEST`;
export const FETCH_ONLINE_HOMEWORK_HF_USAGE_SUCCESS = `FETCH_${ACTION_OBJECT_NAME}_SUCCESS`;
export const FETCH_ONLINE_HOMEWORK_HF_USAGE_FAILURE = `FETCH_${ACTION_OBJECT_NAME}_FAILURE`;

const DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

const buildOnlineHomeworkHFUsageURL = (groupId) =>
  buildUrl(`/groups/${groupId}/hf-online-usage`);

export const fetchOnlineHomeworkHFUsage = (groupId) =>
  createApiActionCreator(
    ACTION_OBJECT_NAME,
    buildOnlineHomeworkHFUsageURL(groupId),
    'GET',
    DISABLE_DEFAULT_ACTION_EXTRAS,
    { groupId },
  );



// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/actions.js